let Utils = {
  normalizeAngle(angle) {
    if (angle >= Math.PI*2) {
      angle -= Math.PI*2;
    }
    if (angle < 0) {
      angle = 2 * Math.PI + angle;
    }
    return angle;
  },

  isBetweenAngle(angle, startAngle, endAngle) {
    if (angle > startAngle && angle < endAngle) {
      return true;
    } else if (endAngle < startAngle && angle + Math.PI*2 > startAngle && angle + Math.PI*2 < endAngle + Math.PI*2) {
      return true;
    } else if (endAngle < startAngle && angle > startAngle && angle < endAngle + Math.PI*2) {
      return true;
    }
    return false;
  },

  getAngle(a1, a2) {
    var a = Utils.normalizeAngle(a2) - Utils.normalizeAngle(a1);
    if (a < 0) {
      a += Math.PI*2;
    }
    return a;
  },

  isIntersectedCurves(a1, a2, a3, a4) {
    let curve1 = Utils.getAngle(a1, a2) + Utils.getAngle(a3, a4);
    let curve2 = Math.max(Math.min(Utils.getAngle(a1, a4), Utils.getAngle(a4, a1)), Math.min(Utils.getAngle(a2, a3), Utils.getAngle(a3, a2)));
    return (curve1 > curve2);
  },
  getRealSizeItem(item){
    let tmpSize=item.size;
      switch (item.productType) {
        case 6: // is charm
          tmpSize = (item.size * item.hookPos.hookW) / 108;
          break;
        case 5: // is rondeo
          tmpSize = (item.imageSize * item.size) / 108;
          break;
        default:
          break;
      }
    return tmpSize;
  }
}

export default Utils;
